import { Link } from "react-router-dom";

export function CommercialFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto py-6 border-t border-gray-200 w-full bg-gray-50">
      <div className="container mx-auto px-4 text-center text-sm text-gray-500">
        <p className="mb-2">&copy; {currentYear} Puglia Life SRL. Tutti i diritti riservati.</p>
        <div className="flex justify-center space-x-4">
          <Link to="/privacy" className="hover:text-brand-primary transition-colors">Privacy Policy</Link>
          <span>|</span>
          <Link to="/dichiarazione-accessibilita" className="hover:text-brand-primary transition-colors font-medium">
            Dichiarazione di Accessibilità
          </Link>
        </div>
      </div>
    </footer>
  );
}
